export default {
  availableAmountOfSeats: 'availableSeatCount',
  totalAmountOfSeats: 'totalSeatCount',
  travelClass: 'travelClass',
}
